import axios from '@/http/axios/index.js'


export default {
    getReports(payload) {
        return axios.get('shelter-fee/reports', { params: payload }).then(res => res.data)
    },
    getClients() {
        return axios.get('shelter-fee/clients').then(res => res.data)
    }
}